// extracted by mini-css-extract-plugin
export var backgroundImage = "callToAction-module--background-image--17905";
export var button = "callToAction-module--button--cb01f";
export var callToAction = "callToAction-module--call-to-action--7815f";
export var ctaTextContainer = "callToAction-module--cta-text-container--4a46e";
export var darkOverlay = "callToAction-module--dark-overlay--7efbb";
export var description = "callToAction-module--description--9ce10";
export var headline = "callToAction-module--headline--e388e";
export var image = "callToAction-module--image--aeecb";
export var leftAligned = "callToAction-module--left-aligned--0b972";